import { defineComponent as _defineComponent } from 'vue'
import 'jquery-validation';

import $ from 'jquery';
import {
    onMounted,
    shallowRef,
    unref,
    watch,
} from 'vue';

import { useGenerateIds } from '#public_ts/composables';

import updateDataAttributes from './data-attributes';


export default /*#__PURE__*/_defineComponent({
  __name: 'input-file',
  props: {
    id: null,
    name: null,
    value: null,
    data: null
  },
  emits: ["input", "control"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: File[]): void;
    (event: 'control', value: HTMLInputElement): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    id?: string;
    name?: string;
    value?: File[];
    data?: Record<string, unknown>;
}


//eslint-disable-next-line no-spaced-func


const input = shallowRef<HTMLInputElement | undefined>();
const generateIds = useGenerateIds();
const controlId = props.id || generateIds();
const controlName = props.name || controlId;

watch(() => props.data, (val) => {
    const _input = unref(input);
    if(_input && val) {
        updateDataAttributes($(_input), val);
    }
}, { deep: true });

watch(() => props.value, (val) => {
    const _input = unref(input);
    if(_input && (!val || !val.length)) {
        //reset file control
        try {
            _input.value = '';
        } catch{ /**/ }
        try {
            _input.type = '';
        } catch{ /**/ }
        try {
            _input.type = 'file';
        } catch{ /**/ }
    }
});

onMounted(() => {
    const _input = unref(input);
    if(_input) {
        if(props.data) {
            updateDataAttributes($(_input), props.data);
        }
    }
});

function onChange(e: Event) {
    const control = (e.target as HTMLInputElement | null);
    const files = control?.files;
    const array: File[] = [];
    if(files) {
        for(let i = 0; i < files.length; i++) {
            const file = files[i];
            if(file) array.push(file);
        }
    }
    emit('input', array);
    if(control) emit('control', control);
}

return { __sfc: true,props, emit, input, generateIds, controlId, controlName, onChange }
}

})